import { ScheduleFrequency } from "PFApp/booking/types/export_booking";
import React from "react";
import { useTranslation } from "react-i18next";

type RepeatColumnProps = {
  repeat: ScheduleFrequency | undefined;
};

export const RepeatColumn = ({ repeat }: RepeatColumnProps): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports" });
  return <span>{repeat ? t(`frequency.${repeat}`) : t("manageReports.reports.table.noSchedulePeriod")}</span>;
};
